import { ApprovalI } from "../approvals/approvalsTypes";
import { realTimeData, realTimeDataTypes } from "./types";

export const addStack = (payload: { approval: ApprovalI }): realTimeDataTypes => ({
  type: realTimeData.ADD_STACK,
  payload,
});

export const updateStack = (payload: { approval: ApprovalI }): realTimeDataTypes => ({
  type: realTimeData.UPDATE_STACK,
  payload,
});

export const removeStack = (payload: { approval: ApprovalI }): realTimeDataTypes => ({
  type: realTimeData.REMOVE_STACK,
  payload,
});

export const resetStack = (payload: "queue" | "history"): realTimeDataTypes => ({
  type: realTimeData.RESET_STACK,
  payload,
});
